import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedAdministrationModule } from '../shared-administration/shared-administration.module';

// Third party
import { Ng2FileInputModule } from 'ng2-file-input';

// Local
import { HelpsManagementComponent } from './helps-management.component';
import { HelpsComponent } from './helps-component/helps.component';
import { CategoryHelpsComponent } from './category-help-component/category-help-component';




@NgModule({
  imports: [
    CommonModule,
    SharedAdministrationModule,
    Ng2FileInputModule
  ],
  declarations: [
    HelpsManagementComponent,
    HelpsComponent,
    CategoryHelpsComponent

  ]
})
export class HelpsManagementModule {}



// WEBPACK FOOTER //
// ./src/app/administration/management_helps/helps-management.module.ts